import { useGame } from '../state/GameContext.jsx';

const MEDALS = ['🥇', '🥈', '🥉'];

export default function RoundResultView({ onNext, isHost }) {
  const { state, send } = useGame();
  const { room } = state;
  if (!room) return null;

  const results = room.currentResults ?? [];
  const participants = room.participants ?? [];

  const getParticipant = (id) => participants.find((p) => p.id === id);

  return (
    <div className="min-h-screen tv-bg-stripe flex flex-col items-center p-4 gap-4">
      <div className="tv-telop text-2xl mt-6">
        ラウンド {room.currentRound} 結果
      </div>

      <div className="w-full max-w-sm flex flex-col gap-3">
        {results.map((r, i) => {
          const p = getParticipant(r.participantId);
          return (
            <div key={r.participantId} className="tv-panel p-3 flex items-center gap-3">
              <span className="text-2xl w-8 text-center">
                {i < 3 ? MEDALS[r.rank - 1] ?? `${r.rank}位` : `${r.rank}位`}
              </span>
              <span className="text-2xl">{p?.emoji}</span>
              <span className="flex-1 font-body font-bold truncate">{p?.nickname}</span>
              <span className="font-num text-xl text-tv-red font-bold">
                {'★'.repeat(r.stars || 0)}
              </span>
              <span className="font-num text-lg font-bold w-10 text-right">
                {r.points}pt
              </span>
            </div>
          );
        })}
      </div>

      <div className="w-full max-w-sm tv-panel-sm p-3">
        <p className="text-center text-sm text-tv-ash mb-2 font-body">累計スコア</p>
        {participants
          .slice()
          .sort((a, b) => (room.totalScores[b.id] ?? 0) - (room.totalScores[a.id] ?? 0))
          .map((p, i) => (
            <div key={p.id} className="flex items-center gap-2 py-1">
              <span className="w-6 text-sm text-center text-tv-ash">{i + 1}</span>
              <span>{p.emoji}</span>
              <span className="flex-1 text-sm font-body truncate">{p.nickname}</span>
              <span className="font-num font-bold text-tv-blue">
                {room.totalScores[p.id] ?? 0}pt
              </span>
            </div>
          ))}
      </div>

      {isHost && (
        <button
          className="tv-btn tv-btn-red text-lg px-8 py-3 mt-2"
          onClick={() => send({ type: 'host:advance' })}
        >
          {room.currentRound >= room.totalRounds ? '最終結果へ' : '次のラウンドへ'}
        </button>
      )}
      {!isHost && (
        <p className="text-tv-ash font-body text-sm">ホストの操作を待っています…</p>
      )}
    </div>
  );
}
